// extracted by mini-css-extract-plugin
export default {"root":"EditLiveRoomWizardTabs_root__-nOtT"};